import dayjs from 'dayjs';

import { Logo } from 'src/components/Svg/Images';
import { Separator } from '@/components/ui/separator';
import { cn } from 'src/lib/utils';

type Props = {
  assetName: string;
  period: string;
  generatedAt: string;
  ref: React.RefObject<HTMLDivElement | null>;
  className?: string;
  content: {
    title: string;
    subtitle: string;
    description: string;
  };
};

const ReportLayout = ({
  assetName,
  period,
  generatedAt,
  children,
  ref,
  className,
  content,
}: React.PropsWithChildren<Props>) => {
  const { title, subtitle, description } = content;

  return (
    <div className={cn('bg-white p-4 md:p-9 grow', className)} ref={ref}>
      <div className="flex justify-between items-start gap-4 mb-8">
        <Logo className="w-[130px] h-[40px]" />
        <span className="text-[10px] text-[#1A5261]">{dayjs(period).format('MMMM YYYY')}</span>
      </div>
      <h3 className="text-xs text-muted-foreground font-semibold mb-2">{assetName}</h3>
      <h1 className="text-2xl text-foreground mb-5">{title}</h1>
      <div className="py-3.5 px-4 bg-[rgba(244,246,247,0.6)] rounded">
        <div className="text-sm text-foreground font-bold mb-2">Verification Protocol</div>
        <div className="text-xs italic text-foreground mb-1">{subtitle}</div>
        <p className="text-xs text-foreground opacity-80">{description}</p>
      </div>
      <Separator className="my-6" />
      <div className="mb-6">{children}</div>
      <div className="text-[9px] text-muted-foreground">
        Generated on {dayjs(generatedAt).format('DD MMMM YYYY, hh:mm A')}
      </div>
    </div>
  );
};

export default ReportLayout;
